/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Remaining_OneInputs */

const en_coaching_remaining_one = /** @type {(inputs: Coaching_Remaining_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 session available`)
};

const id_coaching_remaining_one = /** @type {(inputs: Coaching_Remaining_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 sesi tersedia`)
};

/**
* | output |
* | --- |
* | "1 session available" |
*
* @param {Coaching_Remaining_OneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_remaining_one = /** @type {((inputs?: Coaching_Remaining_OneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Remaining_OneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_remaining_one(inputs)
	return en_coaching_remaining_one(inputs)
});